export const dossiersReducer = (state:[], action:any) => {
    switch (action.type) {
        case 'SET_DOSSIERS':
            state = action.payload;
            return state;
        default:
            return state || [];
    }
}

export const dossiertypesReducer = (state:[], action:any) => {
    switch (action.type) {
        case 'SET_DOSSIERTYPES':
            state = action.payload;
            return state;
        default:
            return state || [];
    }
}
